import { fromClassArray, fromClass } from "fw-model";

export class UserMetaData {
    DateLastLoginUTC: string = null;
    DateCreatedUtc: string;
    DateUpdatedUtc: string;
    ChangeEmailAddressRequest: ChangeEmailAddressRequest;
}

export class User {
    Id: string = null;
    EmailAddress: string = null;
    FirstName: string = null;
    LastName: string = null;
    Type: UserType = null;
    IsActive: boolean = true;

    @fromClass MetaData: UserMetaData;
}

export class ChangeEmailAddressRequest {
    PendingEmailAddress: string;
}

export class NewUser extends User {
    Password: string = null;
    ConfirmPassword: string = null;
}

export enum UserType {
    SystemAdministrator = 0,
    GlobalAdministrator = 1,
    GlobalSupport = 2,
    TransferPlannerAPIService = 3
}

export enum AccountLockOutType {
    Temporary = 0,
    ResetRequired = 1
}

export class ChangeEmail {
    ExistingEmailAddress: string;
    PendingEmailAddress: string;
}
